import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const TiktokIcon = ({
  className,
  fill = 'currentColor',
  ...props
}: React.ComponentProps<'svg'>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={mergeClassNames('h-[20px] w-[20px]', className)}
    {...props}
  >
    <path
      d="M16.2689 2H12.8983V15.6232C12.8983 17.2464 11.602 18.5797 9.98872 18.5797C8.37544 18.5797 7.07907 17.2464 7.07907 15.6232C7.07907 14.029 8.34664 12.7246 9.90231 12.6667V9.24639C6.47409 9.30433 3.7085 12.1159 3.7085 15.6232C3.7085 19.1594 6.53171 22 10.0175 22C13.5033 22 16.3265 19.1304 16.3265 15.6232V8.63767C17.5941 9.56522 19.1497 10.1159 20.7918 10.1449V6.72464C18.2567 6.63768 16.2689 4.55072 16.2689 2Z"
      fill={fill}
    />
  </svg>
);

export default TiktokIcon;
